import { useContext, useState } from "react";
import CalendarsContext from "../../../context/NewCalendarContext/CalendarsContext";
import { clearDeleteEditEventModall } from "../../../context/NewCalendarContext/Actions";
import { Button, Dialog, DialogContent, TextField } from "@material-ui/core"
import styles from '../Calendars.module.css'
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useMutation, useQuery } from "@apollo/client";
import { GET_EVENT, DELETE_EVENT, GET_COUNT_EVENT_NONWORKINGDAY, GET_ALL_EVENT_CALENDAR_BY_MONTH_YRAR } from "../../../Querys/querys";
import { SuccessfulAlert } from "../../../alerts/successAlerts";
import moment from "moment";


const DeleteEvent = ({ calendarDate, date }: any) => {
    const { state, dispatch } = useContext(CalendarsContext)
    const [activo, setactivo] = useState(false)
    const [deleteCalendars] = useMutation(DELETE_EVENT, {
        refetchQueries: [
            { query: GET_COUNT_EVENT_NONWORKINGDAY },
            { query: GET_ALL_EVENT_CALENDAR_BY_MONTH_YRAR, variables: { calendarId: parseInt(state._id), month: parseInt(moment(date).format('M')), year: parseInt(moment(date).format('YYYY')) } },
        ],
    })

    const handleChange = (e: any) => {
        if (e.target.value === 'ELIMINAR') {
            setactivo(true)
        } else {
            setactivo(false)
        }
    }

    const handleClose = () => {
        clearDeleteEditEventModall({}, dispatch);
    }

    const handleOnDelete = () => {
        const idDoc = Number(state.idAux)
        deleteCalendars({
            variables: {
                deleteEventId: idDoc
            }
        }).then (() => {
            SuccessfulAlert({text:"Evento eliminado con éxito"});
        })
        handleClose()
    }

    const { loading, data } = useQuery(GET_EVENT, {
        variables: {
            id: state.idAux,
        }
    });

    if (loading) return null;

    const event = data?.GET_EVENT;

    // const initialValues = () => {
    //     return {
    //         mensaje: ""
    //     }
    // }

    return (
        <Dialog open={state.deleteEditEventModal} aria-labelledby="form-dialog-title" onClose={handleClose} maxWidth={"md"}>
            <div className={styles.em_container}>
                <div className={styles.contenedorCerrarModal}>
                    <div
                        className={styles.cerrarModal}
                        onClick={() => handleClose()}>
                    </div>
                </div>
                <div className={styles.contenedorPrincipal}>
                    <div className={styles.iconoEliminar}>
                    </div>
                    <div className={styles.em_titulo}>
                        ¿Est&aacute;s seguro de que quieres eliminar el Evento?
                    </div>
                    {/* <div className={styles.em_mensajePrtincipal}>
                        <span className={styles.tituloDatosUpdate}>{event?.name}</span>
                    </div> */}
                    <div className={styles.em_mensajePrtincipal}>
                        <span >Una vez eliminado no podr&aacute;s recuperar la informaci&oacute;n</span>
                        <br/>
                        <span >Escribe ELIMINAR  para confirmar</span>
                    </div>
                    <div>
                        <input
                            className={styles.input}
                            type="text"
                            onChange={(e) => handleChange(e)}
                        />
                    </div>
                </div>
            </div>
            <div className={styles.em_contenedorBotones}>
                <button
                    className={styles.em_botonCancelar}
                    onClick={() => handleClose()}
                >
                    Cancelar
                </button>
                {(activo === true ?
                    <button
                        className={styles.em_botonConfirmarActivo}
                        onClick={() => handleOnDelete()}
                    >
                        <div className={styles.em_iconoConfirmarEliminar}></div>
                        <div>
                            Confirmar
                        </div>
                    </button>
                    :
                    <button className={styles.em_botonConfirmarInactivo}>
                        <div className={styles.em_iconoConfirmarEliminar}></div>
                        <div>
                            Confirmar
                        </div>
                    </button>
                )}

            </div>
        </Dialog>
    )
}


export default DeleteEvent